
import { Vue, Component, Watch } from 'vue-property-decorator';
import { mainStore, adminStore, avaliacaoStore, backblazeFileStore } from '@/store';
import DateComponent from '@/components/DateComponent.vue';
import { IAvaliacaoForm, IAvaliacaoGestor } from '@/interfaces/avaliacao';
import Photo from './PhotoEmployee.vue';
import ChangeStatus from './ChangeStatus.vue';
import _ from 'lodash';
import api from '@/api';

@Component({
  components: {
    DateComponent,
    Photo,
    ChangeStatus,
  },
})
export default class Create extends Vue {
  form: IAvaliacaoForm = {
    razao_social: '',
    cnpj: '',
    nome_funcionario: '',
    data_admissao: null,
    termino_experiencia: null,
    departure_id: null,
    cargo: '',
    supervisor_id: null,
  };

  avaliacao_gestor: IAvaliacaoGestor = {
    disciplina: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
      segundo_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    aprendizagem: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    produtividade: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    iniciativa: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    interesse_responsabilidade: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
      segundo_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    relacionamento_interpessoal: {
      primeiro_ponto: {
        nota: '',
        justificativa: '',
      },
      segundo_ponto: {
        nota: '',
        justificativa: '',
      },
    },
    resultados: '',
    pontos_favoraveis: '',
    pontos_desenvolver: '',
  };

  avaliacao_gerente: string = null;

  criterios: string[] = [
    'disciplina',
    'aprendizagem',
    'produtividade',
    'iniciativa',
    'interesse_responsabilidade',
    'relacionamento_interpessoal',
  ];

  errorMessages: any = {
    disciplina: 'Critério de Disciplina tem campos obrigatórios não preenchidos',
    aprendizagem: 'Critério de Aprendizagem tem campos obrigatórios não preenchidos',
    produtividade: 'Critério de Produtividade tem campos obrigatórios não preenchidos',
    iniciativa: 'Critério de Iniciativa tem campos obrigatórios não preenchidos',
    interesse_responsabilidade: 'Critério de Interesse e Responsabilidade tem campos obrigatórios não preenchidos',
    relacionamento_interpessoal: 'Critério de Relacionamento Interpessoal tem campos obrigatórios não preenchidos',
    resultados: 'Critério de Resultados tem campos obrigatórios não preenchidos',
    pontos_favoraveis: 'Critério de Pontos favoráveis tem campos obrigatórios não preenchidos',
    pontos_desenvolver: 'Critério de Pontos a desenvolver tem campos obrigatórios não preenchidos',
  };

  numeroExperiencia: number = 1;
  salvarIsDisabled: boolean = false;
  isDiretor: boolean = false;
  isSupervisor: boolean = false;
  isGerente: boolean = false;
  isRh: boolean = false;
  approvedIsDisabled: boolean = false;
  isCreate: boolean = true;
  isLoading: boolean = false;
  colaborador: any = null;
  searchColaborador: string = '';
  haveColaborador: boolean = false;
  srcAvatar: string = '';
  fotoColaborador: Blob = null;
  dominio_id: number = null;

  gerente_id: number = null;
  haveAvaliacaoGerente: boolean = false;
  autoApprove: boolean = false;
  autoApproveGerente: boolean = false;

  @Watch('form.data_admissao', { deep: true })
  onChangeDataAdmissao(val) {
    if (val) {
      let dataExpedicao = new Date(val);
      if (this.numeroExperiencia == 1) {
        dataExpedicao.setDate(dataExpedicao.getDate() + 44);
      } else {
        dataExpedicao.setDate(dataExpedicao.getDate() + 89);
      }
      this.form.termino_experiencia = dataExpedicao.toISOString().split('.')[0];
    } else {
      this.form.termino_experiencia = null;
    }
  }

  onChangeHaveColaborador() {
    this.colaborador = null;
    this.form.nome_funcionario = '';
  }

  onChangePhoto(file: Blob) {
    this.srcAvatar = URL.createObjectURL(file);
    this.fotoColaborador = file;
  }

  get rulesNotas() {
    return [(v) => !!v || 'Campo obrigatório'];
  }

  get usersOptions() {
    let userOptions = adminStore.usersFranchising;

    return userOptions.map((user) => {
      if (user.dominio_id) {
        user.full_name = user.dominio_id + ' - ' + user.full_name;
      }
      return user;
    });
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  get routeParams() {
    return _.get(this.$router.currentRoute, 'params', {});
  }

  get avaliacaoId() {
    return _.toNumber(_.get(this.routeParams, 'id', '0'));
  }

  get rules() {
    return [(v) => !!v || 'Campo obrigatório'];
  }

  get fileImg() {
    return backblazeFileStore.backblazeFiles[0];
  }

  get avaliacao() {
    return avaliacaoStore.avaliacao;
  }

  public justificativaRules(nota) {
    if (nota != '' && parseInt(nota) < 3) {
      return [(v) => !!v || 'Campo obrigatório'];
    } else {
      return [];
    }
  }

  public async getBucketObjectsByPrefix() {
    if (this.colaborador) {
      try {
        const response = await api.getBucketObjectsByPrefix(
          mainStore.token,
          'user',
          String(this.colaborador.id),
          'user'
        );
        if (response) {
          return response.data;
        }
      } catch (e) {
        await mainStore.checkApiError(<any>e);
      }
    }
  }

  async formIsValid() {
    if (this.autoApprove || this.autoApproveGerente) return { isValid: true, message: '' };
    for (let key_info in this.form) {
      if (key_info != 'avaliacao_gestor') {
        if (this.haveColaborador && key_info == 'nome_funcionario') {
          if (this.colaborador == null) {
            return {
              isValid: false,
              message: 'Informações sobre o colaborador não preenchidas',
            };
          }
        } else {
          if (this.form[key_info] == null || this.form[key_info] == '') {
            return {
              isValid: false,
              message: 'Informações sobre o colaborador não preenchidas',
            };
          }
        }
      }
    }

    if (!this.isCreate && this.currentUser?.role?.level != 3) {
      for (let key_criteria in this.avaliacao_gestor) {
        if (this.criterios.includes(key_criteria)) {
          for (let key_step in this.avaliacao_gestor[key_criteria]) {
            let step = this.avaliacao_gestor[key_criteria][key_step];
            if (step['nota'] == '') {
              return {
                isValid: false,
                message: this.errorMessages[key_criteria],
              };
            } else if (parseInt(step['nota']) < 3 && step['justificativa'] == '') {
              return {
                isValid: false,
                message: this.errorMessages[key_criteria],
              };
            }
          }
        }
      }
    }

    if (this.isGerente && (this.avaliacao_gerente == null || this.avaliacao_gerente == '')) {
      return {
        isValid: false,
        message: 'Preencha o campo Avaliação - Gerente',
      };
    }

    return { isValid: true, message: '' };
  }

  async submitAndApprove(is_approved?: boolean) {
    await this.$swal({
      icon: 'warning',
      title: is_approved ? 'Aprovar avaliação ?' : 'Reprovar avaliação ?',
      html: `A avaliação <b>não poderá mais ser editada</b> após a confirmação`,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Voltar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (this.isSupervisor) {
          this.submit(true, false, is_approved, false);
        } else if (this.isGerente) {
          this.submit(false, false, is_approved, true);
        } else if (this.isRh) {
          this.submit(false, false, is_approved, false, true);
        } else {
          this.submit(false, true, is_approved, false);
        }
      }
    });
  }

  async submit(
    aprov_gestor?: boolean,
    aprov_diretor?: boolean,
    aprov?: boolean,
    aprov_gerente?: boolean,
    aprov_rh?: boolean
  ) {
    this.isLoading = true;

    let formValidation = await this.formIsValid();

    if (!formValidation.isValid) {
      mainStore.addNotification({
        content: formValidation.message,
        color: 'error',
        timeout: 5000,
      });
      this.isLoading = false;
      return;
    }

    if (this.avaliacaoId) {
      let payload: any = {};
      let file: Blob = null;

      for (let key_colaborador in this.form) {
        payload[key_colaborador] = this.form[key_colaborador];
      }

      if (!this.autoApprove && !this.autoApproveGerente) {
        payload['avaliacao_gestor'] = this.avaliacao_gestor;
      }

      if (aprov_gestor) {
        payload['aprovacao_gestor'] = aprov;
      }

      if (aprov_diretor) {
        payload['aprovacao_diretor'] = aprov;
      }

      if (aprov_gerente) {
        payload['aprovacao_gerente'] = aprov;
        payload['avaliacao_gerente'] = this.avaliacao_gerente;
      }

      if (aprov_rh) {
        payload['aprovacao_gestor'] = aprov;
        if (this.gerente_id != null) payload['aprovacao_gerente'] = aprov;
      }

      if (this.gerente_id) {
        payload['gerente_id'] = this.gerente_id;
      } else if (this.avaliacao.gerente_id && this.gerente_id == null) {
        payload['gerente_id'] = null;
      }

      payload['id'] = this.avaliacaoId;
      payload['numero_experiencia'] = this.numeroExperiencia;

      if (this.colaborador) {
        payload['colaborador_id'] = this.colaborador.id;
        if (this.colaborador.full_name.split('- ')[1]) {
          payload['nome_funcionario'] = this.colaborador.full_name.split('- ')[1];
        } else {
          payload['nome_funcionario'] = this.colaborador.full_name;
        }
      } else {
        payload['colaborador_id'] = null;
        payload['dominio_id'] = this.dominio_id;
      }

      if (this.fotoColaborador) {
        file = this.fotoColaborador;
      }

      let response = await avaliacaoStore.updateAvaliacao({
        avaliacao_in: payload,
        file: file,
      });

      if (response) {
        if (this.isSupervisor && response.aprovacao_gestor !== null) {
          this.approvedIsDisabled = true;
        } else if (this.isGerente && response.aprovacao_gerente !== null) {
          this.approvedIsDisabled = true;
          this.haveAvaliacaoGerente = true;
        } else if (this.isDiretor && response.aprovacao_diretor !== null) {
          this.approvedIsDisabled = true;
        } else if (
          (aprov_rh && response.aprovacao_gestor !== null) ||
          response.aprovacao_gerente !== null ||
          response.aprovacao_diretor !== null
        ) {
          this.approvedIsDisabled = true;
        }

        if (response.aprovacao_gestor !== null || response.aprovacao_diretor !== null) {
          this.salvarIsDisabled = true;
        }

        mainStore.addNotification({
          content: 'Avaliação atualizada',
          color: 'success',
          timeout: 2500,
        });

        this.fotoColaborador = null;
      }
    } else {
      let payload: any = {};
      let file: Blob = null;

      for (let key_colaborador in this.form) {
        payload[key_colaborador] = this.form[key_colaborador];
      }

      payload['avaliacao_gestor'] = this.avaliacao_gestor;

      if (this.colaborador) {
        payload['colaborador_id'] = this.colaborador.id;
        if (this.colaborador.full_name.split('- ')[1]) {
          payload['nome_funcionario'] = this.colaborador.full_name.split('- ')[1];
        } else {
          payload['nome_funcionario'] = this.colaborador.full_name;
        }
      } else {
        payload['colaborador_id'] = null;
        payload['dominio_id'] = this.dominio_id;
      }

      if (this.gerente_id) {
        payload['gerente_id'] = this.gerente_id;
      }

      if (this.fotoColaborador) {
        file = this.fotoColaborador;
      }

      payload.numero_experiencia = this.numeroExperiencia;

      let response = await avaliacaoStore.createAvaliacao({
        avaliacao_in: payload,
        file,
      });

      if (response) {
        mainStore.addNotification({
          content: 'Avaliação criada',
          color: 'success',
          timeout: 2500,
        });

        this.isCreate = false;
        this.$router.push('/main/avaliacao/all');
      }
    }

    this.isLoading = false;
  }

  statusChanged() {
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  }

  async mounted() {
    this.isLoading = true;
    await adminStore.getUsersFranchising();

    if (this.avaliacaoId) {
      this.isCreate = false;
      let avaliacao = await avaliacaoStore.getAvaliacao(this.avaliacaoId);

      if (avaliacao) {
        await backblazeFileStore.getBackblazeFiles({
          model: 'Avaliacao',
          model_id: avaliacao.numero_experiencia == 1 ? avaliacao.id : avaliacao.avaliacao_anterior_id,
        });

        if (this.fileImg) {
          const response = await api.downloadBackblazeFile(mainStore.token, {
            id: this.fileImg.id,
          });
          if (response.data) {
            this.srcAvatar = response.data.b64string;
          }
        }

        if (avaliacao.colaborador_id) {
          this.haveColaborador = true;
        }

        if (avaliacao.dominio_id) {
          this.dominio_id = avaliacao.dominio_id;
        }

        this.numeroExperiencia = avaliacao.numero_experiencia;

        if (this.numeroExperiencia == 2) {
          this.avaliacao_gestor.aprendizagem.segundo_ponto = {
            nota: '',
            justificativa: '',
          };
          this.avaliacao_gestor.aprendizagem.terceiro_ponto = {
            nota: '',
            justificativa: '',
          };
        }

        for (let key_colaborador in avaliacao) {
          if (key_colaborador == 'colaborador_id') {
            if (avaliacao[key_colaborador]) {
              this.colaborador = this.usersOptions.find((user) => {
                return user.id === avaliacao[key_colaborador];
              });
            }
          } else if (key_colaborador == 'avaliacao_gestor') {
            if (avaliacao[key_colaborador] !== null) {
              if (avaliacao[key_colaborador]['auto_approve']) {
                this.autoApprove = true;
              } else {
                this.avaliacao_gestor = avaliacao[key_colaborador];
              }
            }
          } else if (avaliacao[key_colaborador] !== null && avaliacao[key_colaborador] != '') {
            this.form[key_colaborador] = avaliacao[key_colaborador];
          }
        }

        if (avaliacao.avaliacao_gerente != null) {
          this.avaliacao_gerente = avaliacao.avaliacao_gerente;
          if (avaliacao.avaliacao_gerente == 'APROVAÇÃO AUTOMÁTICA') {
            this.autoApproveGerente = true;
          }

          this.haveAvaliacaoGerente = true;
        }

        if (avaliacao.gerente_id) {
          this.gerente_id = avaliacao.gerente_id;
        }

        if (this.currentUser.id == avaliacao.supervisor_id) {
          this.isSupervisor = true;
        } else if (this.currentUser.id == avaliacao.gerente_id) {
          this.isGerente = true;
        } else if (this.currentUser.id == 494) {
          this.isDiretor = true;
        }

        if (this.isSupervisor && avaliacao.aprovacao_gestor !== null) {
          this.approvedIsDisabled = true;
        } else if (this.isGerente && avaliacao.aprovacao_gerente !== null) {
          this.approvedIsDisabled = true;
        } else if (this.isDiretor && avaliacao.aprovacao_diretor !== null) {
          this.approvedIsDisabled = true;
        }

        if (
          this.currentUser?.role?.level != 3 &&
          (avaliacao.aprovacao_gestor !== null || avaliacao.aprovacao_diretor !== null)
        ) {
          this.salvarIsDisabled = true;
        }

        if (
          this.currentUser.departure_id == 3 &&
          (this.currentUser.id != avaliacao.supervisor_id || this.currentUser.id != avaliacao.gerente_id)
        ) {
          this.isRh = true;
        }
      }
    }

    //watch adicionado aqui para que ele so execute após mounted ser executado
    this.$watch('haveColaborador', this.onChangeHaveColaborador);

    this.isLoading = false;
  }
}
